import axios from "axios";
import {
  FETCHING_CUSTOMER_DETAILS,
  FETCHING_CUSTOMER_DETAILS_SUCCEEDED,
  FETCHING_CUSTOMER_DETAILS_FAILED,
  UPDATING_CUSTOMER_DETAILS,
  UPDATING_CUSTOMER_DETAILS_SUCCEEDED,
  UPDATING_CUSTOMER_DETAILS_FAILED,
} from "constants/actionTypes";

import { createAction } from "redux-actions";
import { call, takeLatest, put } from "redux-saga/effects";
import buildUrl from "build-url";

const API_URL = process.env.REACT_APP_API_URL;
const ACCOUNTS_BASE_URL = `${API_URL}/api/1.0/accounts`;

export const fetchCustomerDetails = createAction(FETCHING_CUSTOMER_DETAILS);
const fetchCustomerDetailsSucceeded = createAction(
  FETCHING_CUSTOMER_DETAILS_SUCCEEDED
);
const fetchCustomerDetailsFailed = createAction(
  FETCHING_CUSTOMER_DETAILS_FAILED
);

function* fetchCustomerData(action) {
  let { limit, query } = action.payload;
  let url = buildUrl(ACCOUNTS_BASE_URL, { path: "/chargebee/customers" });
  const fetchCustomerDetailsAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: { limit, query },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCustomerDetailsAPI);
    yield put(fetchCustomerDetailsSucceeded(response));
  } catch (error) {
    yield put(fetchCustomerDetailsFailed(error));
  }
}

export const updatingCustomerDetails = createAction(UPDATING_CUSTOMER_DETAILS);
const updatingCustomerDetailsSucceeded = createAction(
  UPDATING_CUSTOMER_DETAILS_SUCCEEDED
);
const updatingCustomerDetailsFailed = createAction(
  UPDATING_CUSTOMER_DETAILS_FAILED
);

function* updatingCustomerData(action) {
  let accountId = _.get(action, "payload.accountId", null);
  let customerId = _.get(action, "payload.customerId", null);

  let url = buildUrl(`${ACCOUNTS_BASE_URL}/chargebee/customers`);

  const customerDetails = {
    accountId,
    customerId,
  };
  const updatingCustomerDataAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: customerDetails,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updatingCustomerDataAPI);
    yield put(updatingCustomerDetailsSucceeded(response));
  } catch (error) {
    yield put(updatingCustomerDetailsFailed(error));
  }
}

export default function* customerDetailSaga() {
  yield takeLatest(FETCHING_CUSTOMER_DETAILS, fetchCustomerData);
  yield takeLatest(UPDATING_CUSTOMER_DETAILS, updatingCustomerData);
}
